import { Layout, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { CloseIcon, MapsIcon, NoImageLogo, SuccessLogo } from "../../asset";
import PrimaryButton from "../button/PrimaryButton";
import MapsFullScreen from "../maps/MapsFullScreen";
import Geocode from "react-geocode";
import { useState } from "react";
import { getImgName } from "../../util";

const ModalPhoto = (props) => {
  const { t } = useTranslation();
  const [loc, setLoc] = useState();
  return (
    <>
      <div
        id="modal-info"
        className={`w-full min-h-full bg-gray-300 bg-opacity-50 top-0 left-0
    fixed justify-center ${props.show ? "" : "hidden"} `}
        onClick={() => props.onClose()}
        style={{ zIndex: 100000000000 }}
      >
        <div className="flex flex-col justify-center items-center">
          <Layout.Header
            style={{
              width: "100%",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "right",
              // zIndex: 1,
              boxShadow: "0px 4px 12px -4px rgba(0, 0, 0, 0.15)",
              height: "90px",
            }}
          >
            <div className="mt-6 flex justify-center">
              <img className="h-10" src={MapsIcon} alt="map" />
              <div className="text-red-100 mt-2 font-bold ml-2 text-xl">
                {props.img ? getImgName(props.img) : "image"}
              </div>
              {/* <div>
            <div className="text-red-100 mt-[-6px] font-bold ml-2 text-xl">{props.address}</div>
            <div className="text-red-100 mt-[5px] font-semibold ml-2">{loc}</div>
          </div> */}
            </div>
            <div
              className="mt-6 flex justify-end ml-[50%] mr-2 cursor-pointer"
              onClick={() => props.onClose()}
            >
              <img className="h-6" src={CloseIcon} alt="map" />
            </div>
          </Layout.Header>
          <div></div>
          <img
            className="mt-20 w-[500px]"
            src={props.photo ? props.photo : NoImageLogo}
            alt="popup"
          />
        </div>
      </div>
      {/* </div> */}
      {/* </Modal> */}
    </>
  );
};
export default ModalPhoto;
